import React from "react";
import { TableHead } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SortableTableHeader } from "@rentablo/components";

interface Props {
  sortField?: string;
  sortDirection?: TableSortDirection;
  sort: (sortField: string) => void;
}

export const AccountsRowHeadings = ({
  sortField,
  sortDirection,
  sort,
}: Props) => {
  const { t } = useTranslation();

  const commonProps = {
    sortField,
    sortDirection,
    isSortable: true,
    onClick: sort,
  };

  return (
    <TableHead
      sx={{
        "& .MuiTableCell-root": {
          paddingY: "18px",
        },
      }}
    >
      <SortableTableHeader
        text={t("csvImport.cashParsingResults.bank_booking_date")}
        sortByName="bank_booking_date.value"
        {...commonProps}
      />
      <SortableTableHeader
        text={t("csvImport.cashParsingResults.counterpart_name")}
        sortByName="counterpart_name.value"
        {...commonProps}
      />

      <SortableTableHeader
        text={t("csvImport.cashParsingResults.purpose")}
        sortByName="purpose.value"
        {...commonProps}
        align="right"
      />
      <SortableTableHeader
        text={t("csvImport.cashParsingResults.amount")}
        sortByName="amount.value"
        {...commonProps}
        align="right"
      />
      <SortableTableHeader text="" sortByName="" />
    </TableHead>
  );
};
